var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("UserLevel box-level-incoming_msg bx-lv-" + _vm.levelClass)},[_c('span',[_c('i',{staticClass:"far fa-gem"}),_vm._v(" "+_vm._s(_vm.level)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }